export default __webpack_public_path__ + "static/media/logo+tag.f4042dfa.jpg";